import { useState } from 'react';
import self from './assets/self.png'

const Self = () => {

    const [questions, setQuestions] = useState(
        [
            {
                question: "Você apostou mais do que realmente poderia perder?",
                response: 0
            },
            {
                question: "Você precisou jogar com quantias maiores de dinheiro para ter a mesma sensação de entusiasmo?",
                response: 0
            },
            {
                question: "Você voltou outro dia para tentar recuperar o dinheiro que perdeu?",
                response: 0
            },
            {
                question: "Você pediu dinheiro emprestado ou vendeu alguma coisa para jogar?",
                response: 0
            },
            {
                question: "Você já sentiu que pode ter problemas com jogos de azar?",
                response: 0
            },
            {
                question: "As pessoas criticaram as suas apostas ou disseram-lhe que você tinha um problema com o jogo, quer você achasse que isso era verdade ou não?",
                response: 0
            },
            {
                question: "Você já se sentiu culpado pela maneira como joga ou pelo que acontece quando você joga?",
                response: 0
            },
            {
                question: "O jogo lhe causou algum problema de saúde, incluindo estresse ou ansiedade?",
                response: 0
            },
            {
                question: "O seu jogo causou algum problema financeiro para você ou sua família?",
                response: 0
            }
        ]
    )
    
    const [total, setTotal] = useState(0)
    const answers = ["Nunca", "Às vezes", "Na maioria das vezes", "Sempre"]

    const changeTotal = (questionIndex, answerIndex) => {
        var newResponse = [...questions];
        newResponse[questionIndex].response = answerIndex;
        setQuestions(newResponse)
        setTotal(newResponse.reduce((n, {response}) => n + response, 0))
    }

    return ( 
        <div className="self-wrapper">

            <div className="self-header">
                <div className="self-header-left">
                    <h2>Índice de Gravidade de Problemas em Jogos de Azar (PGSI)</h2>
                    <span><span className="blue">Instruções: </span>Responda às seguintes perguntas ao pensar sobre o seu comportamento de jogo nos últimos 12 meses.</span>
                </div>
                <div className="self-header-right">
                    <img src={self} alt="" />
                </div>
            </div>

            <div className="self-questions">
                {questions.map((question, index) => (
                   <div className="question-div">
                        <h2>{question.question}</h2>
                        <div className="possible-answers">
                            {answers.map((answer, answerIndex) => (
                                <div className="answer-div" style={answerIndex === question.response ? {backgroundColor: "#0360D8", color: '#ffffff' } : {backgroundColor: "#ffffff", color: '#000000' } } onClick={() => changeTotal(index, answerIndex)}>
                                   ({answerIndex}) {answer}
                                </div>
                            ))}
                        </div>
                   </div> 
                ))}
            </div>

            <div className="self-footer">
                <div className="self-footer-left">
                    <h2>Referências</h2>
                    <p>Ferris, J., and Wynne, H. J. (2001). The Canadian Problem Gambling Index. Final Report. Ottawa: Canadian Centre on Substance Abuse.</p>
                    <p>Wynne, H. (2003). Introducing the Problem Gambling Index. Edmonton, AB: Wynne Resources.</p>
                    <p>Miller, et al. (2013). Validation of the problem gambling severity index using confirmatory factor analysis and Rasch modelling. International Journal of Methods in Psychiatric Research, 22(3).</p>
                    <p>Linhas de orientação técnica para a intervenção em comportamentos aditivos e dependências sem substância: a perturbação de jogo. Serviço de Intervenção nos Comportamentos Aditivos e nas Dependências (SICAD), 2017.</p>
                </div>
                <div className="self-footer-right">
                    <h2>Índice de Gravidade do Jogo Problemático (PGSI)</h2>
                    <p className='result'><span>Sua pontuação:</span> {total} {total === 1 ? 'ponto' :'pontos'}</p>
                    <ol>
                        <li>0 pontos: Jogador não problemático, sem problemas de jogo</li>
                        <li>1-2 pontos: Jogador de baixo risco, com poucas consequências negativas ou não identificadas</li>
                        <li>3-7 pontos: Jogador de risco moderado, com algumas consequências negativas</li>
                        <li>8-27 pontos: Jogador problemático, revela problemas de jogo, com consequências negativas e possível perda de controle</li>
                    </ol>
                </div>
            </div>
        </div>
     );
}
 
export default Self;